import React, { MouseEventHandler, useEffect, useRef, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import closeIcon from '../../assets/close.svg';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import CardContainer from '../../components/container/CardContainer';
import MainContainer from "../../components/container/MainContainer";
import CustomButton from '../../components/CustomButton/CustomButton';
import useInputValidation from '../../hooks/useInputValidation';
import { getDetails, postDetails } from '../../services/http/http.service';
import { showMessageOnFailure } from '../../store/error.actions';
import { hideLoader, showLoader } from '../../store/Loader/loader.slice';
import { useAppDispatch, useAppSelector } from '../../store/storeRequests';
import APIList from '../../utils/constants/APIList';
import BreadcrumbData from '../../utils/constants/BreadcrumbData.constants';
import { APIResponseCodes } from '../../utils/constants/keys.constants';
import StoreSelectors from '../../utils/constants/StoreSelectors.constants';
import './commercials.css';
import { NavList } from '../../utils/constants/navigation';
import { message } from '../../utils/constants/Messages';


const Commercials: React.FunctionComponent<any> = () => {

    const isMounted = useRef(false)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { bindValue } = useInputValidation()
    const { access } = useAppSelector(StoreSelectors.USER_STATE)

    const [accordionConfig, setAccordionConfig] = useState([] as Array<{
        id: number, versionId: number, groupVersion: string, groupId: number, label: string, agree: boolean,
        groupName: string, groupType: string, groupPricing: { flat_based: { minHits: number, perHitRate: number }, tableData: Array<{ id: number, minHit: number, maxHit: number, rate: number }> }
    }>)
    const [originalPricing, setOriginalPricing] = useState<any>([]);
    const [updatedPricing, setUpdatedPricing] = useState<any>([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState<{ [key: number]: string }>({});
    const [selectedPricingTypes, setSelectedPricingTypes] = useState<{ [key: number]: 'flat_based' | 'slab_based' | null }>({});
    const [agreePayement, setAgreePayement] = useState<{ [key: number]: boolean }>({});
    const [refferalCode, setRefferalCode] = useState({ code: '', coupon_type: '', messsage: '', applicable: false })

    const applyCouponToGroup = (groupPricing: any, couponPricing: any) => {
        const updatedGroupPricing: any = {
            ...groupPricing,
            flatBased: {
                minHits: groupPricing.flatBased.minHits,
                perHitRate: Number(Math.min(
                    Number(groupPricing.flatBased.perHitRate),
                    Number(couponPricing.flatBased.perHitRate)
                )),
            },
        };
        updatedGroupPricing.slabBased = groupPricing.slabBased.map((groupSlab: any) => {
            let minRate = groupSlab.rate;
            couponPricing.slabBased.forEach((couponSlab: any) => {
                if (
                    groupSlab.minHit <= couponSlab.maxHit &&
                    groupSlab.maxHit >= couponSlab.minHit
                ) {
                    if (couponSlab.rate < minRate) {
                        minRate = couponSlab.rate;
                    }
                }
            });

            return {
                ...groupSlab,
                rate: minRate,
            };
        });

        return updatedGroupPricing;
    };
    const getData = async () => {
        if (access.hasPodAccess === false) return
        dispatch(showLoader(message.GETTING_COMMERCIAL_DETAIL))
        const response = await getDetails(APIList.GET_ALL_PROD_CART_ITEMS, getData)
        if (response.statusCode === APIResponseCodes.SUCCESS) {

            let prodCartItemsCheckout: Array<any> = [];
            response.data.api_list.forEach((item: any) => {
                prodCartItemsCheckout.push(item.group_version_id)
            })
            const payload: any = {
                group_version_id: prodCartItemsCheckout
            };
            const response1 = await postDetails(APIList.COMMERCIALS_GETALL_PRICING, payload, getData)
            const data: Array<any> = []
            if (response1.statusCode === APIResponseCodes.SUCCESS) {
                response1.data.forEach((item: any) => {
                    const infoItem = response.data.info.find((info: any) => info.name === item.group_type);
                    const id = infoItem ? infoItem.id : null;
                    data.push({
                        id: id,
                        versionId: item.group_version_id,
                        groupVersion: item.group_version,
                        groupId: item.group_id,
                        label: item.group_type,
                        groupName: item.group_name,
                        groupType: item.group_type,
                        groupPricing: {
                            flat_based: item.version_pricing.flat_based,
                            tableData: item.version_pricing.slab_based
                        },
                        agree: false,
                    })
                })

                setOriginalPricing(data);
                const categoryArr: Array<any> = []
                accordionConfig.forEach(item => categoryArr.push({
                    group_id: item.groupId,
                    group_version_id: item.id
                }))

                if (response.data.ref_code.length !== 0) {
                    const refResponse = await postDetails(APIList.VALIDATE_REFFERAL_CODE, { ref_code: response.data.ref_code, groupList: categoryArr })
                    if (response.statusCode === APIResponseCodes.SUCCESS) {
                        if (refResponse.data.applicable === false) {
                            setRefferalCode({ code: '', coupon_type: '', messsage: '', applicable: false })
                        }
                        if (response.data.applicable && response.data.coupon_type === "flat_off") {
                            const updatedAccordionConfig: any = accordionConfig.map((conf: any) => {
                                const updatedFlatoffPricing = response.data.updatedPricing
                                if (updatedFlatoffPricing) {
                                    const updatedGroupPricing = applyCouponToGroup(
                                        {
                                            flatBased: {
                                                minHits: conf.groupPricing.flat_based?.minHits,
                                                perHitRate: Number(conf.groupPricing.flat_based?.perHitRate)
                                            },
                                            slabBased: conf.groupPricing.tableData.map((slab: any) => ({
                                                minHit: Number(slab.minHit),
                                                maxHit: Number(slab.maxHit),
                                                rate: Number(slab.rate),
                                            })),
                                        },
                                        {
                                            flatBased: {
                                                minHits: updatedFlatoffPricing.flat_based.minHits,
                                                perHitRate: Number(updatedFlatoffPricing.flat_based?.perHitRate)
                                            },
                                            slabBased: updatedFlatoffPricing.slab_based.map((slab: any) => ({
                                                minHit: Number(slab.minHit),
                                                maxHit: Number(slab.maxHit),
                                                rate: Number(slab.rate),
                                            })),
                                        }
                                    );

                                    return {
                                        ...conf,
                                        groupPricing: {
                                            flat_based: {
                                                minHits: updatedGroupPricing.flatBased.minHits,
                                                perHitRate: updatedGroupPricing.flatBased.perHitRate
                                            },
                                            tableData: updatedGroupPricing.slabBased.map((slab: any) => ({
                                                id: slab.minHit,
                                                minHit: slab.minHit,
                                                maxHit: slab.maxHit,
                                                rate: slab.rate,
                                            })),
                                        }
                                    };
                                }
                                return conf;
                            }
                            );
                            setUpdatedPricing(updatedAccordionConfig);
                            setRefferalCode({ ...refferalCode, coupon_type: response.data.coupon_type, applicable: response.data.applicable, messsage: response.data.msg })
                        }
                        else if (response.data.applicable && response.data.coupon_type === "discount") {
                            const updatedAccordionConfig: any = accordionConfig.map((conf: any) => {
                                const updatedDiscountPricing = response.data.updatedPricing.find((up: any) => up.group_id === conf.groupId);
                                if (updatedDiscountPricing) {
                                    return {
                                        ...conf,
                                        groupPricing: {
                                            flat_based: updatedDiscountPricing.discountedPricing.flat_based,
                                            tableData: updatedDiscountPricing.discountedPricing.slab_based
                                        }
                                    }
                                }
                                return conf;
                            })
                            setUpdatedPricing(updatedAccordionConfig);
                            setRefferalCode({ ...refferalCode, coupon_type: response.data.coupon_type, applicable: response.data.applicable, messsage: response.data.msg })
                        }
                    }
                }
            }
            setAccordionConfig(data)
            if (data.length === 0) {
                setRefferalCode({ code: '', coupon_type: '', messsage: '', applicable: false })
            }
            dispatch(hideLoader())
        } else {
            dispatch(hideLoader())
        }
    }


    useEffect(() => {
        if (access.hasProdAccess) {
            isMounted.current = false
        }
        if (isMounted.current === true || !access.hasProdAccess) return
        getData()
        isMounted.current = true
    }, [access])

    const handleAgree = (ev: MouseEventHandler<HTMLButtonElement>, key: number) => {
        setAgreePayement((prev) => ({
            ...prev,
            [key]: true,
        }));
    }

    /** On click alert proceed */
    const handleProceed = async () => {
        dispatch(showLoader(message.SAVING_AGREEMENT))
        const payload: Array<any> = []
        accordionConfig.forEach(conf => payload.push({ id: conf.id, groupVersionId: conf.versionId, agree: agreePayement[conf.versionId] || false, paymentType: selectedPaymentType[conf.versionId] || null, pricingType: selectedPricingTypes[conf.versionId] || null, }))
        const response = await postDetails(APIList.SAVE_COMMERCIALS, !refferalCode.applicable ? { info: payload } : { info: payload, ref_code: refferalCode.code, ref_type: refferalCode.coupon_type, }, handleProceed)
        dispatch(hideLoader())
        if (response.statusCode === APIResponseCodes.SUCCESS) {
            navigate(NavList.PRODUCTION_CHECKOUT)
        }
    }

    const isCommercialValid = () => {
        return accordionConfig.every(conf => {
            const paymentType = selectedPaymentType[conf.versionId];
            const pricingType = selectedPricingTypes[conf.versionId];
            const agree = agreePayement[conf.versionId];
            return paymentType && pricingType && agree;
        });
    };

    const validateRefferalCode = async () => {
        if (refferalCode.code.length < 5 || !refferalCode.code.match(/[A-Za-z0-9]+$/)) {
            return
        }
        dispatch(showLoader(message.VALIDATE_REFERRAL_COUPON))
        const categoryArr: Array<any> = []
        accordionConfig.forEach(item => categoryArr.push({
            group_id: item.groupId,
            group_version_id: item.versionId
        }))

        const response = await postDetails(APIList.VALIDATE_REFFERAL_CODE, { ref_code: refferalCode.code, groupList: categoryArr }, validateRefferalCode)
        dispatch(hideLoader())

        if (response.statusCode === APIResponseCodes.SUCCESS) {
            if (response.data.applicable === false) {
                dispatch(showMessageOnFailure(response.data.msg))
            }
            if (response.data.applicable && response.data.coupon_type === "flat_off") {
                const updatedAccordionConfig: any = accordionConfig.map((conf: any) => {
                    const updatedFlatoffPricing = response.data.updatedPricing

                    if (updatedFlatoffPricing) {
                        const updatedGroupPricing = applyCouponToGroup(
                            {
                                flatBased: {
                                    minHits: conf.groupPricing.flat_based?.minHits,
                                    perHitRate: Number(conf.groupPricing.flat_based.perHitRate)
                                },
                                slabBased: conf.groupPricing.tableData.map((slab: any) => ({
                                    minHit: Number(slab.minHit),
                                    maxHit: Number(slab.maxHit),
                                    rate: Number(slab.rate),
                                })),
                            },
                            {
                                flatBased: {
                                    minHits: updatedFlatoffPricing.flat_based.minHits,
                                    perHitRate: Number(updatedFlatoffPricing.flat_based.perHitRate)
                                },
                                slabBased: updatedFlatoffPricing.slab_based.map((slab: any) => ({
                                    minHit: Number(slab.minHit),
                                    maxHit: Number(slab.maxHit),
                                    rate: Number(slab.rate),
                                })),
                            }
                        );

                        return {
                            ...conf,
                            groupPricing: {
                                flat_based: {
                                    minHits: updatedGroupPricing.flatBased.minHits,
                                    perHitRate: updatedGroupPricing.flatBased.perHitRate
                                },
                                tableData: updatedGroupPricing.slabBased.map((slab: any) => ({
                                    id: slab.minHit,
                                    minHit: slab.minHit,
                                    maxHit: slab.maxHit,
                                    rate: slab.rate,
                                })),
                            }
                        };
                    }
                    return conf;
                });
                setUpdatedPricing(updatedAccordionConfig);
                setRefferalCode({ ...refferalCode, coupon_type: response.data.coupon_type, applicable: response.data.applicable, messsage: response.data.msg })
            }
            else if (response.data.applicable && response.data.coupon_type === "discount") {
                const updatedAccordionConfig: any = accordionConfig.map((conf: any) => {
                    const updatedDiscountPricing = response.data.updatedPricing.find((up: any) => up.group_id === conf.groupId);
                    if (updatedDiscountPricing) {
                        return {
                            ...conf,
                            groupPricing: {
                                flat_based: updatedDiscountPricing.discountedPricing.flat_based,
                                tableData: updatedDiscountPricing.discountedPricing.slab_based
                            }
                        }
                    }
                    return conf;
                })
                setUpdatedPricing(updatedAccordionConfig);
                setRefferalCode({ ...refferalCode, coupon_type: response.data.coupon_type, applicable: response.data.applicable, messsage: response.data.msg })
            }
        }
    }
    const handlePaymentTypeChange = (version_id: number, type: string) => {
        setSelectedPaymentType((prev) => ({
            ...prev,
            [version_id]: type,
        }));

    };

    /** Remove referral code */
    const removeReferralCode = async () => {
        dispatch(showLoader(message.REMOVING_REFERRAL_COUPON))
        try {
            const response = await getDetails(APIList.REMOVE_REFFERAL_CODE, removeReferralCode)
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                setRefferalCode({ code: '', coupon_type: '', messsage: '', applicable: false })
                setAccordionConfig(originalPricing);

            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch(hideLoader())
            console.log(error)
        }
    }
    const handlePricingTypeChange = (versionId: number, type: 'flat_based' | 'slab_based') => {
        setSelectedPricingTypes((prev) => ({
            ...prev,
            [versionId]: type,
        }));
    };
    return (
        <MainContainer>
            <Breadcrumb routes={BreadcrumbData.commercials} />
            <h2 className='text-capitalize mf-active-header'>commercials</h2>

            <Accordion defaultActiveKey={"1"} className='mf-commercial-accordion mb-5'>
                {
                    accordionConfig.length !== 0 ?
                        accordionConfig.map((conf, index) => (
                            <div className="mb-4" key={index}>
                                <CardContainer>
                                    <Accordion.Item className='bg-white border-0' eventKey={`${index + 1}`}>
                                        <Accordion.Header>
                                            <p className='text-primary-color font-16 weight-500 pe-3 mb-1'>{conf.groupName}
                                                <span className="ms-3" style={{ color: "#383838c4" }} >
                                                    &#x2022; <span className='mf-type text-capitalize'>{conf.groupType}</span>
                                                </span>
                                                <span className="ms-3" style={{ color: "#383838c4" }} >
                                                    &#x2022; <span className='mf-type text-capitalize'>{conf.groupVersion}</span>
                                                </span>
                                            </p>
                                        </Accordion.Header>
                                        <Accordion.Body className='text-primary-color font-14 weight-400 pt-0 commercial-acc-body'>
                                            <p className="mb-0 text-sec-color font-14 mb-2 weight-500">Pricing for the consumption of Group</p>
                                            <div className='ms-0 mb-2'>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={`paymentType-${conf.versionId}`}
                                                        value="postpaid"
                                                        checked={selectedPaymentType[conf.versionId] === "postpaid"}
                                                        onChange={() => handlePaymentTypeChange(conf.versionId, "postpaid")}
                                                    />
                                                    Postpaid
                                                </label>
                                                <label className="ms-3">
                                                    <input
                                                        type="radio"
                                                        name={`paymentType-${conf.versionId}`}
                                                        value="prepaid"
                                                        checked={selectedPaymentType[conf.versionId] === "prepaid"}
                                                        onChange={() => handlePaymentTypeChange(conf.versionId, "prepaid")}
                                                    />
                                                    Prepaid
                                                </label>
                                            </div>
                                            {conf.groupPricing.flat_based?.minHits && <div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`flat-based-${conf.versionId}`}
                                                        checked={selectedPricingTypes[conf.versionId] === 'flat_based'}
                                                        onChange={() => handlePricingTypeChange(conf.versionId, 'flat_based')}
                                                    />
                                                    <label className="form-check-label mb-0 text-sec-color font-14 mb-1 weight-500" htmlFor={`flat-based-${conf.versionId}`}>
                                                        Flat Based
                                                    </label>
                                                </div>
                                                <div className="row no-negative-margin commercial-table-head py-2 px-1">
                                                    <div className="col-8 col-md-3 col-lg-3 font-14 weight-500">NCT<span className='text-capitalize text-primary-color font-12 weight-500 ms-1'>(monthly hits slab)</span></div>
                                                    <div className="col-4 col-md-9 col-lg-9 font-14 weight-500 text-end">Price <span className='text-capitalize text-primary-color font-12 weight-500 ms-1'>(in ₹)</span></div>
                                                </div>
                                                <div className="row no-negative-margin commercial-table-body px-1">
                                                    <p className="col-8 col-md-3 col-lg-3 mb-0 font-13 weight-400">{conf.groupPricing.flat_based?.minHits}</p>
                                                    <p className="col-4 col-md-9 col-lg-9 mb-0 font-13 weight-400 text-end">
                                                        {refferalCode.applicable && updatedPricing.length > 0 ? (
                                                            <>
                                                                <span style={{ textDecoration: 'line-through' }} className='text-danger'>
                                                                    {conf.groupPricing.flat_based?.perHitRate}
                                                                </span>
                                                                <span className="ms-2 weight-600">
                                                                    {
                                                                        updatedPricing
                                                                            .find((up: any) => up.versionId === conf.versionId)
                                                                            ?.groupPricing.flat_based?.perHitRate
                                                                    }
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span className='weight-600'>
                                                                {conf.groupPricing.flat_based?.perHitRate}
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>}
                                            {conf?.groupPricing?.tableData && <div>

                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`slab-based-${conf.versionId}`}
                                                        checked={selectedPricingTypes[conf.versionId] === 'slab_based'}
                                                        onChange={() => handlePricingTypeChange(conf.versionId, 'slab_based')}
                                                    />
                                                    <label className="form-check-label mb-0 text-sec-color font-14 mb-1 weight-500" htmlFor={`slab-based-${conf.versionId}`}>
                                                        Slab Based
                                                    </label>
                                                </div>
                                                <div className="row no-negative-margin commercial-table-head py-2 px-1">
                                                    <div className="col-4 col-md-3 col-lg-3 font-14 weight-500">Min Hit
                                                    </div>
                                                    <div className="col-4 col-md-3 col-lg-3 font-14 weight-500">Max Hit
                                                    </div>
                                                    <div className="col-4 col-md-6 col-lg-6 font-14 weight-500 text-end">Price <span className='text-capitalize text-primary-color font-12 weight-500 ms-1'>(in ₹)</span></div>
                                                </div>

                                                {
                                                    conf.groupPricing.tableData.map((item, index) => {
                                                        const updatedGroup = updatedPricing.find((up: any) => up.versionId === conf.versionId);
                                                        const updatedSlab = updatedGroup?.groupPricing?.tableData.find(
                                                            (slab: any) => slab.minHit === item.minHit && slab.maxHit === item.maxHit
                                                        );
                                                        return (
                                                            <div key={index} className="row no-negative-margin commercial-table-body px-1">
                                                                <p className="col-4 col-md-3 col-lg-3 mb-0 font-13 weight-400">{item.minHit}</p>
                                                                <p className="col-4 col-md-3 col-lg-3 mb-0 font-13 weight-400">{item.maxHit}</p>
                                                                <p className='col-4 col-md-6 col-lg-6 mb-0 font-13 weight-400 text-end'>
                                                                    {refferalCode.applicable && updatedSlab ? (
                                                                        <>
                                                                            <span style={{ textDecoration: 'line-through' }} className='text-danger'>
                                                                                {item.rate}
                                                                            </span>
                                                                            <span className="ms-2 weight-600">
                                                                                {updatedSlab.rate}
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <span className='weight-600'>
                                                                            {item.rate}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            </div>
                                                        )
                                                    }
                                                    )
                                                }
                                            </div>}

                                            <CustomButton type='button' onClick={(ev: any) => handleAgree(ev, conf.versionId)}>{!agreePayement[conf.versionId] ? 'Agree' : 'Agreed  ✔'}</CustomButton>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </CardContainer>
                            </div>
                        ))
                        :
                        <div className="text-center py-3 no-data-with-view">
                            <p className="mb-0 weight-500 font-14 text-primary-color mb-2">No APIs added to cart for checkout...</p>
                            <button onClick={() => navigate(NavList.API_LISTING_PRODUCTION)} className="border-0 font-13 text-sec-color weight-500">View approved APIs {'>'}</button>
                        </div>
                }
            </Accordion>

            {
                accordionConfig.length !== 0 &&
                <div className="mb-5">

                    <div className="d-flex coupon-container align-items-center justify-content-between">
                        <div
                            className="coupon-input-container bg-white d-inline position-relative"
                            data-border={(refferalCode.code.length >= 1 && refferalCode.code.length < 5) || (refferalCode.code.length >= 1 && !refferalCode.code.match(/[A-Za-z0-9]+$/))}
                            {...bindValue('refferalCode')}
                        >
                            <input
                                type="text"
                                name="refferalCode"
                                className='border-0 pe-2 refferal-code-input'
                                placeholder='Referral Code'
                                onChange={(ev) => {
                                    setRefferalCode({ applicable: false, coupon_type: '', messsage: '', code: ev.target.value })
                                }}
                                value={refferalCode.code}
                                max-width={12}
                                min-width={5}
                                pattern="[A-Za-z0-9]+"
                            />
                            {
                                refferalCode.applicable ?
                                    <div className="referal-code-delete cursor-pointer" onClick={removeReferralCode}>
                                        <img width={18} height={18} src={closeIcon} alt="close" />
                                    </div>
                                    :
                                    <button onClick={validateRefferalCode} type='button' className='text-capitalize text-white border-0 font-13 weight-500'>{refferalCode.applicable ? 'Applied' : 'Apply'}</button>
                            }
                        </div>
                        <CustomButton onClick={handleProceed}
                            disabled={!isCommercialValid()}
                        >Proceed</CustomButton>
                    </div>
                    <p className="mb-0 mt-2 font-14 refferal-success-message weight-500">{refferalCode.messsage}</p>
                </div>
            }

        </MainContainer>
    )
}

export default Commercials